// OLD
$(function () {
  function positionFilter() {
    if (window.innerWidth <= 991) {
      if (!document.querySelector('#mobile-contact-seller-modal .modal-content .contact-seller-form')) {
        $('#mobile-contact-seller-modal').find('.modal-content').append($('.contact-seller-form'));
      } else if (!document.querySelector('.xs-transfer .contact-group')) {
        $('.xs-transfer').append($('.transfer-target'));
      }
    } else if (!document.querySelector('.md-hidden.col-lg-4 .contact-seller-form')) {
      $('.md-hidden .back-wrapper').append($('.contact-seller-form'));
    } else if (!document.querySelector('.lg-transfer .contact-group')) {
      $('.lg-transfer').append($('.transfer-target'));
    }

    if (!document.querySelector('#mobile-call-seller-modal .modal-content .call-seller-form')) {
      // Always append the contact seller form to the modal content
      $('#mobile-call-seller-modal').find('.modal-content').append($('.call-seller-form'));
    }
  }

  positionFilter();

  $(window).resize(positionFilter);
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/position_filter.js